import { Alert, Button } from '@mui/material';
import React, { useState } from 'react';

import { ActionPermissions } from '../../../@types';
import { isUserHasPermission } from '../../../configs/permissions';
import { useGetUserSystemPermissions } from '../../../queries/user-query';

interface MobileBlockFieldProps {
  blockMessage: string;
  onBypass: () => void;
}

export const InteractionBlockField: React.FC<MobileBlockFieldProps> = ({
  blockMessage,
  onBypass,
}) => {
  const [bypassed, setBypassed] = useState(false);
  const permissionsQuery = useGetUserSystemPermissions();
  const permissions = permissionsQuery.data || [];

  const canBypass = isUserHasPermission(
    ActionPermissions.Configure_Interactions_Bypass_Mandatory,
    permissions
  );

  const handleBypass = () => {
    setBypassed(true);
    onBypass();
  };

  if (bypassed) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        Block bypassed: {blockMessage}
      </Alert>
    );
  }

  return (
    <>
      <Alert severity="error" sx={{ mb: 2 }}>
        {blockMessage || 'This action is blocked.'}
      </Alert>
      {canBypass && (
        <Button
          variant="outlined"
          color="warning"
          size="small"
          onClick={handleBypass}
          fullWidth
          sx={{ mb: 2 }}
        >
          Bypass Block
        </Button>
      )}
    </>
  );
};
